import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis, CartesianGrid } from 'recharts';
import type { MonthPoint } from '@shared/types';
import { formatCompactCop } from '@shared/format';
import { CHART, tooltipStyle } from './chartTheme';

/** Monthly lost-sales trend (red bars). */
export function LostSalesBarChart({ data, height = 240 }: { data: MonthPoint[]; height?: number }) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} margin={{ top: 8, right: 8, left: 4, bottom: 0 }}>
        <CartesianGrid stroke={CHART.grid} vertical={false} />
        <XAxis
          dataKey="month"
          tick={{ fill: CHART.axis, fontSize: CHART.axisFont, fontFamily: CHART.fontFamily }}
          tickLine={false}
          axisLine={{ stroke: CHART.grid }}
        />
        <YAxis
          tickFormatter={(v) => formatCompactCop(v)}
          tick={{ fill: CHART.axis, fontSize: CHART.axisFont, fontFamily: CHART.fontFamily }}
          tickLine={false}
          axisLine={false}
          width={52}
        />
        <Tooltip
          cursor={{ fill: 'rgba(255,255,255,0.03)' }}
          contentStyle={tooltipStyle}
          formatter={(v: number) => [formatCompactCop(v), 'Ventas perdidas']}
          labelStyle={{ color: '#9CA3AF' }}
        />
        <Bar dataKey="value" fill={CHART.bar} radius={[4, 4, 0, 0]} maxBarSize={46} />
      </BarChart>
    </ResponsiveContainer>
  );
}
